import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getEstimationProductList } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const EstimationProduct = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  catCode,
  selectedProduct,
  index,
  disabled,
  dropView
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [fetchResponse, setFetchResponse] = useState([])

  console.log(`selectedProduct`, selectedProduct);
  
  const loadOptions = async () => {
    setIsLoading(true)
    const data = await getEstimationProductList(catCode?.value)
    setIsLoading(false)
    const response = data?.data?.map(dta => {
      return {
        label: dta?.product_code && ucfirst(dta.product_code),
        value: dta.id,
        ...dta,
      }
    })
    if (index == 0) {
      setFetchResponse(response)
    } else {
      const usedPayroll = selectedProduct?.map(
        dt => dt?.product_id?.id != "" && dt?.product_id?.id
      )
      setFetchResponse(() => {
        const unUsedPayroll = response.filter(item1 => {
          return !usedPayroll?.some(item2 => item2 === item1.value)
        })
        return unUsedPayroll
      })
    }
  }
  useEffect(() => {
    if (catCode?.value) {
      loadOptions()
    }
  }, [catCode?.value])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isDisabled={disabled ? true : false}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              // menuPortalTarget={document.querySelector(
              //   target ? target : ".modal"
              // )}
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
              menuPlacement={dropView ? "top" : "bottom"}
            />
          )
        }}
      />
    </div>
  )
}

export default EstimationProduct
